import React from "react";
import { Box } from "app/components/common";
import Animated, {
  Layout,
  RollInRight,
  RollOutRight,
} from "react-native-reanimated";
import FastImage from "react-native-fast-image";
import { StarImage } from "./RatingStar";
import normalize from "app/utils/normalize";
import { Platform } from "react-native";

const isWeb = Platform.OS === "web";

const AnimatedStarView = ({ children, starNumber, previousStarSelected }) => {
  return isWeb ? (
    <Box>{children}</Box>
  ) : (
    <Animated.View
      layout={Layout}
      entering={RollInRight.duration(200).delay(
        getDelay(starNumber, previousStarSelected),
      )}
      exiting={RollOutRight.duration(200).delay(starNumber * 50)}
    >
      {children}
    </Animated.View>
  );
};

const getDelay = (starNumber: number, previousStarSelected: number) => {
  const indexNumber =
    starNumber - previousStarSelected > 0
      ? starNumber - previousStarSelected
      : 0;
  return 50 * indexNumber;
};

export interface IStarAnimatedProps {
  right?: number;
  left?: number;
  top?: number;
  rotateY?: number;
  bottom?: number;
  isToggle: boolean;
  starNumber: number;
  previousStarSelected: number;
  imageStyle?: {};
}

export const StarAnimated = ({
  right,
  left,
  top,
  bottom,
  isToggle = false,
  previousStarSelected,
  starNumber,
  rotateY = 0,
  imageStyle = { height: normalize(40), width: normalize(35) },
}: IStarAnimatedProps) => {
  return isToggle ? (
    <AnimatedStarView
      starNumber={starNumber}
      previousStarSelected={previousStarSelected}
    >
      <Box
        position={starNumber > 1 ? "absolute" : "relative"}
        transform={[{ rotateZ: `${rotateY}deg` }]}
        right={right}
        left={left}
        top={top}
        bottom={bottom}
      >
        <FastImage source={StarImage} style={imageStyle} />
      </Box>
    </AnimatedStarView>
  ) : null;
};
